import React from "react";
import { Modal } from "antd";
import { AiFillCloseCircle } from "react-icons/ai";
import { IoMdNotifications } from "react-icons/io";
import "./notificationModelPage.css";

const notifications = [
  {
    title: "Payment Confirmation Received",
    message:
      "Your payment has been successfully received. Thank you for completing the required formalities.",
    icon: (
      <IoMdNotifications
        size={25}
        className="notification-model-bell-icon me-2 mt-1"
      />
    ),
  },
  {
    title: "Compliance Checklist Released",
    message: (
      <>
        A new training and compliance checklist has been issued. Complete it
        before <strong>May 10, 2025</strong>.
      </>
    ),
    icon: (
      <IoMdNotifications
        size={25}
        className="notification-model-bell-icon me-2 mt-1"
      />
    ),
  },
  {
    title: "Application Rejected",
    message:
      "Your application has been rejected due to missing or invalid documentation. Please review and reapply if needed.",
    icon: (
      <AiFillCloseCircle
        size={25}
        className="notification-model-close-icon me-2 mt-1"
      />
    ),
  },
];

const NotificationModalPage = ({ open, handleCancel }) => {
  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      footer={null}
      closable
      width={500}
      centered
    >
      <div className="view-notification-model-page p-3">
        <h5 className="mb-3">Notification</h5>
        <div className="d-flex flex-column gap-3 mt-4">
          {notifications.map((item, index) => (
            <div key={index} className="d-flex align-items-start">
              <div>{item.icon}</div>
              <div>
                <h6 className="mb-1">{item.title}</h6>
                <p className="mb-1">{item.message}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center border-top mt-4 pt-3">
          <span className="all-notification-text">See all notifications</span>
        </div>
      </div>
    </Modal>
  );
};

export default NotificationModalPage;
